import { getPriceDiff, getSpreadPctDisplay, getSpreadUnit, SpreadUnit, toBig, type Security } from '@talos/kyoko';

export interface CustomRateSpreadDisplay {
  unit?: string;
  value: string;
}

export function getCustomRateSpreadDisplay({
  bidPrice,
  offerPrice,
  security,
}: {
  bidPrice: string;
  offerPrice: string;
  security: Security | undefined;
}): CustomRateSpreadDisplay | undefined {
  const bid = toBig(bidPrice);
  const offer = toBig(offerPrice);

  if (bid?.gt(0) !== true || offer?.gt(0) !== true || bid.gt(offer)) {
    return undefined;
  }

  const spreadUnit = getSpreadUnit(security, false);

  if (spreadUnit === SpreadUnit.PRICE) {
    return {
      value: getPriceDiff(bidPrice, offerPrice),
      unit: security?.QuoteCurrency,
    };
  }

  const value = getSpreadPctDisplay(bidPrice, offerPrice);

  return {
    value,
    unit: value.endsWith('%') ? undefined : 'BPS',
  };
}
